import React from 'react';
import { useTranslation } from 'react-i18next';
import { ActivityProps } from './AllServices';
import { DropdownOptions } from '../dropdown/Dropdown';
import styles from './AllServices.module.scss';

export const ActivityDisplay = React.memo(
    (props: { item: DropdownOptions; activityProps: ActivityProps }) => {
        const { t } = useTranslation();

        try {
            const {
                item,
                activityProps: { displayItemText, handleOnStart },
            } = props;
            const activity = item?.item;
            const activityName = item?.item?.Item;

            if (item && activity && activityName) {
                return (
                    <div
                        key={`action-${activityName}`}
                        style={{ marginBottom: '20px' }}
                    >
                        <button
                            type="button"
                            onClick={() => handleOnStart(activity)}
                            className={styles.linkText}
                            aria-label={t('Accessibility.StartActivity', 'Start activity: {{name}}', { name: displayItemText(item) })}
                        >
                            {displayItemText(item) + ' >'}
                        </button>
                    </div>
                );
            } else {
                return null;
            }
        } catch {
            return null;
        }
    },
);
